import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const list = css`
  list-style: none;
`

export const seeMore = css`
  padding-top: ${spacing(3)};
`
